import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getFavotitesInfo } from '../store/favorites/actions';
import { getChannelContent, getLoadButtonText } from "../store/channel/actions";
import { getGenres } from "../store/projects/actions";
import { getFilterNavigationMenu } from "../store/filterSave/actions";
// import { GlobalFonts } from '../styles/fonts.js';
import { GlobalStyle } from '../styles/styles.js';
import Home from '../pages/home/Home'
import Catalog from '../pages/catalog/Catalog.jsx'
import About from '../pages/about/About.jsx'
import Favorites from '../pages/favorites/Favorites.jsx'
import Channel from '../pages/channel/Channel.jsx'
import Collections from "../pages/collections/Collections.jsx";
import Collection from "../pages/collection/Collection";
import Profile from "../pages/profile/Profile.jsx";
import Header from '../components/Header/Header.jsx'
import Footer from '../components/Footer/Footer.jsx'
import Project from '../pages/project/Project.jsx'
import Auth from '../pages/auth/Auth'
import Event from '../pages/event/Event.jsx'
import Events from '../pages/events/Events.jsx'
import SearchResult from "../pages/searchresults/SearchResult";
import PasswordReset from "../pages/passwordreset/PasswordReset";
import PrivateRoute from "../components/private-route/private-route";
import FeedbackPage from '../pages/feedbackPage/FeedbackPage';
import NotFound from '../pages/404/404';
import i18n from "i18next";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

const Page = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [searchWorld, setSearchWorld] = useState("");

    const dispatch = useDispatch();

    const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
    const token = useSelector((store) => store.auth.dataToken.token);
    const channelContent = useSelector((store) => store.channelContent.channelContent);
    const productionsContent = useSelector((store) => store.channelContent.productionsContent);

    const _wholeSiteSearch = (value) => {
        setSearchWorld(value);
    };

    // componentDidMount / componentWillUnmount
    useEffect(() => {
        if (!channelContent) {
            dispatch(getChannelContent('channels'));
        }
        if (!productionsContent) {
            dispatch(getChannelContent('productions'));
        }
        // текст кнопки скачивания каталога нужен в Header/Footer на любой странице
        dispatch(getLoadButtonText());

        const onResize = () => { setWindowWidth(window.innerWidth) };
        window.addEventListener("resize", onResize);

        token && dispatch(getFavotitesInfo(token));
        dispatch(getGenres());

        document.title = i18n.t(`title.all`) //title
        dispatch(getFilterNavigationMenu());

        return () => { window.removeEventListener("resize", onResize) };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isMobile = windowWidth < 768

    return (
        <>
            {/* Add global styles to pages*/}
            < GlobalStyle />
            <Router>
                <Header channelContent={channelContent} isMobile={isMobile} _wholeSiteSearch={(value) => _wholeSiteSearch(value)} />
                <Switch>
                    <Route path="/" exact>
                        <Home isMobile={windowWidth} />
                    </Route>
                    <Route path="/catalog" exact>
                        <Catalog />
                    </Route>
                    <Route path="/catalog/:id?" exact>
                        <Project />
                    </Route>
                    <Route path="/events" exact>
                        {/* <NotFound /> */}
                        <Events isMobile={windowWidth} />
                    </Route>
                    <Route path="/events/:id?" exact>
                        <Event />
                        {/* <NotFound /> */}
                    </Route>
                    <Route path="/collections" exact>
                        <Collections />
                    </Route>
                    <Route path="/collections/:id?" exact>
                        <Collection />
                    </Route>
                    <Route path="/about">
                        <About />
                    </Route>
                    <PrivateRoute
                        exact
                        path="/favorites"
                        render={() => {
                            return (
                                <Favorites />
                            );
                        }}
                    />
                    <PrivateRoute
                        exact
                        path="/profile"
                        render={() => {
                            return (
                                <Profile />
                            );
                        }}
                    />
                    <Route path="/channel/:id?" exact>
                        <Channel />
                    </Route>
                    <Route path="/search" exact>
                        <SearchResult searchWorld={searchWorld} />
                    </Route>
                    <Route path="/feedback" exact>
                        <FeedbackPage />
                    </Route>
                    {
                        (isLoggedIn)
                            ? <>
                                <Route path="/password/reset/:id?" exact>
                                    <Redirect to="/profile" />
                                </Route>
                                <Route path="/auth" exact>
                                    <Redirect to="/profile" />
                                </Route>
                                <Route path="*" component={NotFound} />
                            </>
                            : null
                    }
                    <Route path="/password/reset/:id?" exact>
                        <PasswordReset />
                    </Route>
                    <Route path="/auth" exact>
                        <Auth />
                    </Route>
                    <Route path="*" component={NotFound} />
                </Switch>
                <Footer channelContent={channelContent} />
            </Router>
        </>
    );
};

export default Page;
